<template>

  <div class="this">
    
    <p v-html="$t('maintenance-intro')"></p>

  </div>
    

</template>


<style scoped>
.this {
  text-align: center;
  padding : 10rem 3rem;
}
</style>

<script>

export default {
  name: 'Maintenance',
  metaInfo () { 
    return { title: this.$t("meta-title") } 
  }

}
</script>



<i18n>
{
  "en": {
    "meta-title": "Winerz  |  Maintenance",
    "maintenance-intro" : "Winerz is actually in maintenance mode.<br /><br />Please come back later, launch is officially on Oct. 13th"
  },
  "fr": {
    "meta-title": "Winerz  |  Maintenance",
    "maintenance-intro" : "Winerz est actuellement en maintenance.<br /><br />Reviens plus tard, lancement officiel prévu le 13 Octobre."
  }
}
</i18n>
